/*
 * Copyright (C) 2021 Quartet Health, Inc - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

import * as React from 'react';
import styled, { keyframes } from 'styled-components';
import { stacking } from '../styles';
import { colors } from '../styles/colors';
import fonts, { fontSizes } from '../styles/fonts';

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const OverlayWrapper = styled.div`
  ${stacking.overlay}
  position: fixed;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.35);
  margin: 0;
`;

const Wrapper = styled.div`
  position: absolute;
  left: calc(50% - 35px);
  top: calc(50% - 35px);
  margin: 0;
`;

const SpinnerDiv = styled.div`
  margin: 0 auto;
  border: 6px solid ${colors.grey20};
  border-radius: 50%;
  border-top: 6px solid ${colors.brandPurple};
  width: 70px;
  height: 70px;
  animation: ${spin} 1.5s linear infinite;
`;

const LoadingText = styled.p`
  text-align: center;
  font: ${fonts.bold(fontSizes.body)};
  color: ${colors.grey100};
`;

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  copy?: string;
  overlay?: boolean;
}

export const Spinner = ({ copy, overlay, ...rest }: Props) => {
  return overlay ? (
    <OverlayWrapper data-test="spinner" {...rest}>
      <SpinnerDiv className="spinner-circle" />
      {copy && <LoadingText>{copy}</LoadingText>}
    </OverlayWrapper>
  ) : (
    <Wrapper data-test="spinner" {...rest}>
      <SpinnerDiv className="spinner-circle" />
      {copy && <LoadingText>{copy}</LoadingText>}
    </Wrapper>
  );
};
